export const PAYMENT_STATUS = {
  PROCESSING: "Processing",
  SUCCESS: "Success",
  FAILURE: "Failed",
};